import { render, staticRenderFns } from "./fixedAssets.vue?vue&type=template&id=c4f0f650&"
import script from "./fixedAssets.vue?vue&type=script&lang=js&"
export * from "./fixedAssets.vue?vue&type=script&lang=js&"
import style0 from "./fixedAssets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports